import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import { UserInfo } from "../../../context";

const ProductionDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["processsaverawproduct", "product"],
    },
    {
      title: "Description",
      dataIndex: ["processsaverawproduct", "description"],
    },
    {
      title: "Unit",
      dataIndex: ["processsaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  //   console.log("selectedData", selectedData);

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      track_id: selectedData !== null ? selectedData.track_id : "",
    };
    axios
      .get("user/commissary/spec-raw-process-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Production Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          {displayDetailsPrint && (
            <Typography.Title level={4} style={{ marginBottom: 15 }}>
              {selectedData.track_id} - Production
            </Typography.Title>
          )}
          <Table
            {...tableProps}
            // pagination={{
            //   position: ["bottomRight"],
            // }}
            pagination={false}
            columns={tableColumns}
            dataSource={
              orderDetailsList.data.length > 0 ? orderDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.raw_id}
          />
        </div>
      )}

      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default ProductionDetails;
